import { EntityKeys, QueryType } from 'utils/reactQuery'
import { GuidelineDTO, GuidelinePageDTO } from 'models/guidelines'
import { ProductKind } from 'constants/product'
import { useAPI } from 'utils/API'
import { useQuery } from '@tanstack/react-query'

enum Endpoints {
  LIST = '/guidelines',
  GET_BY_PRODUCT_KIND = '/guidelines/{productKind}',
}

/**
 * Calls backend-platform `GET /guidelines` (ISSUE-1675).
 * Returns the list of Notion guidelines available to the authenticated creative.
 * Language defaults to the user's stored language; pass `language` to override.
 */
export function useListGuidelines(language?: string, enabled = true) {
  const api = useAPI<Endpoints>()

  return useQuery({
    queryKey: [EntityKeys.GUIDELINE, QueryType.LIST, { language: language ?? null }],
    queryFn: () => api.get<GuidelineDTO[]>(
      Endpoints.LIST,
      {},
      true,
      {
        params: language ? { language } : {}
      }
    ),
    enabled
  })
}

/**
 * Calls backend-platform `GET /guidelines/{productKind}` (ISSUE-1675).
 * Returns the full Notion page (structured blocks) for the given ProductKind.
 * 404 when the ProductKind has no mapping or no Notion match.
 */
export function useGetGuidelinePageByProductKind(productKind: ProductKind | undefined, language?: string, enabled = true) {
  const api = useAPI<Endpoints>()

  return useQuery({
    queryKey: [EntityKeys.GUIDELINE, QueryType.GET_ONE, { productKind: productKind ?? null, language: language ?? null }],
    queryFn: () => api.get<GuidelinePageDTO>(
      Endpoints.GET_BY_PRODUCT_KIND,
      { productKind: productKind! },
      true,
      {
        params: language ? { language } : {}
      }
    ),
    enabled: enabled && !!productKind
  })
}
